import { Button } from '@/ui/buttons/Button';
import { ProductGroup } from '@vimond/services/rest-api/types';
import React from 'react';

type ProductGroupCardProps = {
  onSelectProductGroup: (id: number) => void;
  productGroup: ProductGroup & {
    isHighlighted?: boolean;
  };
};

const ProductGroupCard: React.FC<ProductGroupCardProps> = ({
  onSelectProductGroup,
  productGroup,
}) => (
  <div
    className={`bg-background-primary p-8 rounded-lg shadow-md flex flex-col gap-2 h-[500px] w-[400px] box-border ${
      productGroup.isHighlighted ? 'border-4 border-primary' : ''
    }`}
  >
    <h2 className="text-text-primary text-2xl font-bold mb-2 break-words">
      {productGroup.name}
    </h2>
    <p className="text-text-primary text-xl mb-4">{productGroup.description}</p>
    <Button
      variant="primary"
      onClick={() => onSelectProductGroup(productGroup.id)}
      className="align-self-center mt-auto"
    >
      Select
    </Button>
  </div>
);

export default ProductGroupCard;
